export default __webpack_public_path__ + "static/media/crayon-pointer-OB.9297851a.png";